<template>
    <FormSection :application-id="application">
        <template #content>
            <div class="p-2 pb-0">
                <div class="col-12 row">
                    <div class="form-group col-8">
                        <label for="vaccine-name"> Vaccine Name <span class="text-danger">*</span> </label>
                        <TypeaheadInput
                            :getData="getVaccineList"
                            :value="selectedVaccine"
                            v-on:valueChanged="selectedVaccineChanged"
                            placeholder="Enter Vaccine Name"
                            :disabled="isViewOnly || isEdit"
                            v-on:blurredInput="v$.immunization.CvxCode.$touch()"
                        />
                        <span v-if="v$.immunization.CvxCode.$error" class="field-invalid"
                            >Vaccine Name is required.</span
                        >
                    </div>
                    <div class="form-group col-4">
                        <label for="status">Type of Record <span class="text-danger">*</span></label>
                        <select
                            class="form-select"
                            v-model="immunization.TypeOfRecord"
                            :disabled="isViewOnly"
                            @blur="v$.immunization.TypeOfRecord.$touch()"
                        >
                            <option :value="null">Select Type of Record</option>
                            <option v-for="type of typeOfRecordEnum" :value="type.value">{{ type.name }}</option>
                        </select>
                        <span v-if="v$.immunization.TypeOfRecord.$error" class="field-invalid"
                            >Type Of Record is required.</span
                        >
                    </div>
                </div>
                <div class="col-12 row">
                    <div class="form-group col-4">
                        <label for="date-of-vaccination">
                            Documentation Date for Declined Vaccine <span class="text-danger">*</span>
                        </label>
                        <DatePicker :options="datePickerOptions" :getDate="handleDateChange">
                            <div class="input-group date datepickerInput">
                                <input
                                    type="text"
                                    name="date-of-vaccination"
                                    class="form-control"
                                    :value="formatDateInput(immunization.DateOfDocumentation)"
                                    placeholder="Select Date"
                                    autocomplete="off"
                                    @change="handleDateInputChange"
                                    :disabled="isViewOnly"
                                    @blur="v$.immunization.DateOfDocumentation.$touch()"
                                />
                                <div class="input-group-addon input-group-append">
                                    <div class="input-group-text">
                                        <i class="fa fa-calendar"></i>
                                    </div>
                                </div>
                                <span v-if="v$.immunization.DateOfDocumentation.$error" class="field-invalid"
                                    >Date Of Documentation is required.</span
                                >
                            </div>
                        </DatePicker>
                    </div>
                    <div class="form-group col-4">
                        <label for="declined-reason">
                            Reason Immunization Was Not Performed <span class="text-danger">*</span>
                        </label>
                        <select
                            class="form-select"
                            v-model="immunization.ReasonNotPerformed"
                            :disabled="isViewOnly"
                            @blur="v$.immunization.ReasonNotPerformed.$touch()"
                        >
                            <option :value="null">Select Reason</option>
                            <option v-for="type of declinedValueSet" :value="type.Code">
                                {{ type.DisplayName }}
                            </option>
                        </select>
                        <span v-if="v$.immunization.ReasonNotPerformed.$error" class="field-invalid"
                            >Reason Immunization is required.</span
                        >
                    </div>
                </div>
                <div class="col-12 row">
                    <div class="form-group col-12">
                        <label for="comments">Comments</label>
                        <textarea
                            class="form-control"
                            name="comments"
                            v-model="immunization.Comments"
                            placeholder="Enter Comments"
                            :disabled="isViewOnly"
                            maxlength="200"
                        ></textarea>
                    </div>
                </div>
            </div>
        </template>
    </FormSection>
</template>

<script src="./DeclinedVaccineForm.ts"></script>
